export enum GlobalEvents {
    LOGIN = 'login',
    LOGOUT = 'logout',
}
